import { AppBar, Box, Button, makeStyles, Toolbar, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { useConfirm } from 'material-ui-confirm';
import { centerPointState, isWaitingForPollState } from 'pages/CustomerBooking/RecoilState';
import { mapBoundsState } from 'pages/CustomerBooking/RecoilState';
import { clientState } from 'pages/CustomerBooking/RecoilState';
import { stepState } from 'pages/CustomerBooking/RecoilState';
import { STEP_STATE_LIVE } from 'pages/CustomerBooking/RecoilState';
import { manualRefreshState } from 'pages/CustomerBooking/RecoilState';
import { bookingState } from 'pages/CustomerBooking/RecoilState';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { useUserState } from 'services/authentication.service';
import { cancelAppointment, cancelBooking } from 'services/booking.service';
import { canCancel, hasArrived } from 'util/bookingStates';
import { useTrackEvent } from 'util/trackEvent';
import { BookingMap } from '../BookingMap';
import { CancelBookingDialog } from '../BookingDetail/CancelBookingDialog';

const useStyles = makeStyles((theme) => {
  return {
    box: {
    },
    mapBox: {
      height: `calc(100vh - ${theme.mixins.toolbar.minHeight+theme.spacing(2)}px)`

    },
    scrollCard: {
      overflowY: 'auto',
      height: '100%'
    },
    title: {
      flexGrow: 1
    }
  }
})
const BookingMapView = ({ match }) => {
  const confirm = useConfirm();
  const history = useHistory()
  const serviceId = match?.params?.serviceId
  const classes = useStyles()

  const booking = useRecoilValue(bookingState);
  const clientData = useRecoilValue(clientState);
  const bounds = useRecoilValue(mapBoundsState);
  const centerPoint = useRecoilValue(centerPointState)
  const setManualRefreshState = useSetRecoilState(manualRefreshState);
  const [isWaitingForPoll, setIsWaitingForPoll] = useRecoilState(isWaitingForPollState);

  const setStepState = useSetRecoilState(stepState)

  const [showCancel, setShowCancel] = useState(false);

  const trackEvent = useTrackEvent()
  useEffect(() => {
    setStepState(STEP_STATE_LIVE)
  }, []);

  useEffect(() => {
    setManualRefreshState(Math.random())
    return () => setManualRefreshState(Math.random())
  }, []);

  // const doCancelAppointment = useCallback(
  //   async () => {
  //     try {
  //       const confirmation = await confirm({
  //         description: "Are you sure you want to cancel this appointment?  Cancellation fees may apply",
  //       })
  //       await cancelAppointment(booking?.appointment?.id)
  //       trackEvent('Map - Cancel Confirmation - OK ', { dialog: 'doCancelAppointment' })
  //       history.replace(`/bookings/${booking?.id}` + history.location.search)
  //     } catch (e) {
  //       trackEvent('Map - Cancel Confirmation - Cancel', { dialog: 'doCancelAppointment' })
  //     } finally {
        
  //     }
  //   },
  //   [booking?.id, confirm],
  // );

  const title = useMemo(() => {
    const waitingDistance = clientData?.markers?.reduce((acc, marker) => {
      return acc += marker?.distance ?? 0
    }, 0)
    let returnText = waitingDistance > 0.1 ? 'Provider - En Route' : 'Provider - Arriving'
    if (hasArrived(booking)) {
      returnText = 'Provider - Arrived'
    }
    return returnText 
  }, [booking, clientData?.markers]);
  return (
    <>
      <CancelBookingDialog
        open={showCancel}
        onConfirm={async (reason) => {
          setIsWaitingForPoll(true)
          setShowCancel(false)
          await cancelAppointment(booking?.appointment?.id, reason)
          trackEvent('Map - Cancel Confirmation - OK ', { dialog: 'doCancelAppointment' })
          history.replace(`/bookings/${booking?.id}` + history.location.search)
        }}
        onClose={async () => {
          trackEvent('Map - Cancel Confirmation - Cancel', { dialog: 'doCancelAppointment' })
          setShowCancel(false)
        }}
      />
      <AppBar elevation={0} position="static" color="secondary" className={clsx(classes.top, classes.appBar)}>
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            {title}
          </Typography>
          {canCancel(booking) &&
            <Button size="small" color="secondary" onClick={() => {
              trackEvent('Map - Cancel Booking - click', {})
              setShowCancel(true)
            }} variant="outlined">Cancel Booking</Button>
          }
        </Toolbar>
      </AppBar>
      <Box className={classes.mapBox}>
        <BookingMap
          booking={booking}
          centerPoint={centerPoint}
          bounds={bounds}
          markerData={clientData?.markers}
          providerCardData={booking?.provider}
          serviceId={serviceId}
        />
      </Box>
    </>
  )
}

export { BookingMapView }